// extracted by mini-css-extract-plugin
module.exports = {"noFooter":"useModalChangeName_noFooter__18onS","buttons":"useModalChangeName_buttons__1oazm"};